import axios from "axios";
import { UploadAfiliadoSempre } from "../models/upload-afiliado-sempre";

export const AFILIADO_URL = `AfiliadoSempre`;

export const afiliadoSempreServices = {
  getById: (id: string) => {
    return axios.get<any>(`${AFILIADO_URL}/${id}`);
  },
  lookup: (queryParams: any) => {
    return axios.get<any>(`${AFILIADO_URL}/Lookup`, {
      params: {
        ...queryParams,
      },
    });
  },
  importar: function (formData: FormData) {
    return axios.post<UploadAfiliadoSempre>(`${AFILIADO_URL}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
        return percentCompleted;
      },
    });
  },
  descargarPlantilla: function () {
    return axios.get(`${AFILIADO_URL}/plantilla`, {
      responseType: 'blob',
    });
  },
};
